export const ActionTypes = {
  SET_SPECIAL_UNITS: "SPECIAL_UNITS_SET",
  SET_FILTERS: "SPECIAL_UNITS_SET_FILTERS",
  ADD_SPECIAL_UNIT: "SPECIAL_UNITS_ADD",
  UPDATE_SPECIAL_UNIT: "SPECIAL_UNITS_UPDATE",
  REMOVE_SPECIAL_UNIT: "SPECIAL_UNITS_REMOVE",
  RESTORE_INITIAL: "SPECIAL_UNITS_RESTORE_INITIAL",
};
